module.exports = __webpack_public_path__ + "img/iqp_logo.7f497100.png";